import { createFormHook } from "@tanstack/react-form";
import type { ComponentType } from "react";

export namespace AppForm {
  export type FormError = {
    readonly message: string;
  };

  export type FormErrors = readonly (FormError | undefined)[];

  export interface TypeRegistry {}

  type DefaultHooks = ReturnType<
    typeof createFormHook<Record<string, ComponentType<any>>, Record<string, ComponentType<any>>>
  >;

  export type RegisteredHooks = TypeRegistry extends { hooks: infer THooks }
    ? THooks
    : DefaultHooks;
  export type UseAppForm = RegisteredHooks["useAppForm"];

  let registeredHooks: RegisteredHooks | null = null;

  export function registerHooks(hooks: RegisteredHooks) {
    registeredHooks = hooks;
  }

  export const useAppForm: UseAppForm = (props) => {
    if (!registeredHooks) {
      throw new Error("AppForm.useAppForm() must be used after AppForm.registerHooks()");
    }

    return registeredHooks.useAppForm(props);
  };
}
